import React from 'react';
import {NavLink} from 'react-router-dom';

import s from './MainMenuButton.css';

function MainMenuButton({text, to, exact = true, isActive}) {
  return (
    <NavLink
      isActive={isActive}
      exact={exact}
      to={to}
      activeClassName={s.Active}
      className={s.MenuButton}
    >
      {text}
    </NavLink>
  );
}

export default MainMenuButton;
